<template>
  <section
    class="Profile-view"
    :loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="w-full" align="right">
      <el-input
        class="!max-w-54 !my-2"
        v-model="searchString"
        placeholder="Search user, text, or document name"
        @keyup.native="onChangeSearchString"
        @clear="onChangeSearchString"
        clearable
      >
        <i slot="prefix" style="margin-top: -7px" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="card mb-3" style="width: 100%">
      <div
        class=""
        style="width: 100%"
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="sidemenu" v-if="Object.entries(allChatsGroupByDate).length > 0">
          <div
            v-for="(value, name, index) in allChatsGroupByDate"
            :key="name"
            class="group-by-date"
          >
            <div class="date-row">
              <span class="left-side">{{ name | getFormattedDate }}</span>
              <div class="right-side !gap-2 flex items-center">
                <a
                  @click="markAsReadChats"
                  v-if="index == 0 && filterType != 'All'"
                  class="mark-all-as-read"
                >
                  Mark all as read
                </a>

                <div v-if="index == 0">
                  <el-select
                    placeholder="Filter"
                    v-model="filterType"
                    class="filter-type-select"
                    @change="onFilterTypeSelected"
                  >
                    <el-option :key="0" :value="'All'" :label="'All'">All</el-option>
                    <el-option :key="1" :value="'Unread'" :label="'Unread'">Unread</el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="notification-row">
              <ul class="list-group list-group-flush" v-if="value && value.length">
                <li
                  class="list-group-item notifcation-item"
                  v-for="(item, index) in value"
                  :key="index"
                  @click="goToDocView(item._id, true)"
                >
                  <div class="item-avatar">
                    {{ item | getUserNameAvatar }}
                    <div class="unread" v-if="!item.is_read"></div>
                  </div>
                  <div class="item-body flex flex-col items-start">
                    <p class="mb-0 text-black-950">
                      <span class="name">
                        {{ item | getUserFullName }}
                      </span>
                      <span class="commented-on">commented on</span>
                      <span class="doc-name">
                        {{ item.title }}
                      </span>
                      {{ item.text | truncate(20, '...') }}
                    </p>

                    <span class="text-dark fw-medium pl-0 opacity-80">
                      {{ item.created_at | getFormattedDateTypeThree }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else class="no-data-for-notification">
          <div class="filter-type-select-wrapper flex items-center !gap-2">
            <el-input
              class="!max-w-54"
              v-model="searchString"
              placeholder="Search user, text, or document name"
              @keyup.native="onChangeSearchString"
              @clear="onChangeSearchString"
              clearable
            >
              <i slot="prefix" style="margin-top: -1px" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select
              placeholder="Filter"
              v-model="filterType"
              class="filter-type-select mt-1"
              @change="onFilterTypeSelected"
              size="mini"
            >
              <el-option :key="0" :value="'All'" :label="'All'">All</el-option>
              <el-option :key="1" :value="'Unread'" :label="'Unread'">Unread</el-option>
            </el-select>
          </div>
          <div class="inner-wrapper">
            <div class="bg-img-wrapper">
              <div class="bg-img chat"></div>
            </div>
            <span>You have no unread chats yet.</span>
            <p>When you receive a chat on a document, it will be displayed here as unread.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  // import axios from "axios";
  import axios from '@/config/axiosWithCancel';
  import { mapActions } from 'vuex';

  export default {
    name: 'notifications-ViewAllChats',
    data() {
      return {
        filterType: 'All',
        searchString: '',
        loading: true,
        allChats: [],
        allChatsGroupByDate: {},
        allChatsGroupByDateAll: {},
        allChatsGroupByDateUnread: {},
      };
    },
    components: {},
    computed: {},
    mounted() {
      this.fetchAllChats();
      this.fetchChats();
    },
    methods: {
      ...mapActions({
        fetchChats: 'dashboard/fetchChats',
      }),
      async onFilterTypeSelected() {
        if (this.filterType == 'All') {
          this.allChatsGroupByDate = this.allChatsGroupByDateAll;
        } else {
          this.allChatsGroupByDate = this.allChatsGroupByDateUnread;
        }
      },
      async onChangeSearchString() {
        // if (this.searchString.length < 3)
        // {
        //   return;
        // }
        this.fetchAllChats();
      },
      goToDocView(document_id, isChat = false) {
        if (isChat) {
          this.markAsReadChats({ document_id });
        }
        if (document) {
          if (document.document_status == 'DRAFT') {
            this.$router.push({
              name: 'employee-documents-custom-document-edit',
              params: {
                employee_document_id: document_id,
              },
            });
          } else {
            this.$router.push({
              name: 'employee-documents-custom-document',
              params: {
                employee_document_id: document_id,
              },
              query: { tab: 'chat' },
            });
          }
        }
      },
      async markAsReadChats(query = {}) {
        try {
          await axios.post('all-documents/mark-as-read-notes', { query });

          if (this.getChatsUnReadCnt > 0) {
            await this.fetchChats();
          }
        } catch (err) {
          console.log('>>> markAsReadChats(), err', err);
        }
      },
      async fetchAllChats() {
        this.searchItems = null;

        try {
          this.loading = true;
          const params = {
            search_string: this.searchString,
          };
          let response = await axios.get('all-documents/get-all-notes', {
            params,
          });

          this.allChats = response.data.data;
          this.allChatsGroupByDateAll = {};
          // allChatsGroupByDate
          this.allChats.forEach((chat) => {
            // 2021-10-14
            var dt = chat.created_at.substring(0, 10);
            if (!Object.prototype.hasOwnProperty.call(this.allChatsGroupByDateAll, dt)) {
              this.allChatsGroupByDateAll[dt] = [];
            }
            this.allChatsGroupByDateAll[dt].push(chat);
          });

          this.allChatsGroupByDateUnread = {};
          this.allChats.forEach((chat) => {
            // 2021-10-14
            if (!chat.is_read) {
              var dt = chat.created_at.substring(0, 10);
              if (!Object.prototype.hasOwnProperty.call(this.allChatsGroupByDateUnread, dt)) {
                this.allChatsGroupByDateUnread[dt] = [];
              }
              this.allChatsGroupByDateUnread[dt].push(chat);
            }
          });

          this.onFilterTypeSelected();
          this.loading = false;
        } catch (err) {
          console.log('>>> fetchAllChats(), #3, err', err);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    border-bottom: none;

    .card-header {
      border-bottom: none;
    }
  }

  .list-group {
    border: none;
    width: 100%;
    max-width: 100%;

    .notifcation-item {
      border: none;
      border-bottom: 1px solid rgba(0, 0, 0, 0.0525);
      cursor: pointer;
      padding: 10px 20px;
      display: grid;
      grid-template-columns: 2.75em 1fr;
      gap: 15px;

      @media (max-width: 499.98px) {
        // display: grid;
        padding: 5px 5px !important;
      }

      .item-avatar {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid var(--brand-500);
        background-color: var(--brand-50);
        color: var(--brand-500);

        .unread {
          position: absolute;
          z-index: 10000;
          width: 7px;
          height: 7px;
          top: 9px;
          left: 28px;
          border-radius: 8px;
          background: var(--brand-500);
        }
      }

      .item-body {
        display: flex;

        .item-body-left-child {
          .left-child {
            @media (min-width: 500px) {
              display: flex;
            }
          }
        }

        p {
          font-size: 13px;
          font-style: italic;
        }

        .name {
          font-style: normal;
          margin-bottom: 0;
          color: var(--black-950) !important;
          min-height: 21px;
          font-weight: 500;
          font-size: 15px !important;

          @media (min-width: 500px) {
            margin-right: 5px;
          }
        }

        .date-time {
          font-style: normal;
          min-width: 100px;
          text-align: right;
          color: rgba(0, 0, 0, 0.5) !important;
          font-size: 12px;

          @media (max-width: 499.98px) {
            min-width: 70px !important;
          }
        }

        .doc-name {
          font-style: normal;
          font-size: 13px !important;
          font-weight: 500;
          color: var(--black-950);
          margin-right: 10px;
          margin-left: 5px;
        }
      }
    }
  }

  // .el-scrollbar {
  //   // border: 1px solid rgba(0, 0, 0, 0.125);
  //   // border-radius: 1px;
  // }
  .group-by-date {
    .date-row {
      padding: 15px 10px;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      justify-content: space-between;

      .mark-all-as-read {
        color: #409eff;
        cursor: pointer;
        margin-right: 20px;
        line-height: 38px;
      }

      .right-side {
        display: flex;
        flex-direction: row;
      }
    }

    .notification-row {
      padding: 0 0px;
    }
  }
</style>

<style lang="scss">
  .all-chats-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }

    hr {
      margin: 13px 0 !important;
    }

    .search-bar {
      display: flex;

      i.el-icon-search {
        margin-top: 10px;
      }

      div.el-input {
        width: 100%;
      }
    }

    .filter-type-select {
      width: 120px;
      margin-right: 10px;
    }

    .no-data-for-notification {
      display: flex;
      flex-direction: column;

      .filter-type-select-wrapper {
        text-align: right;
        margin-right: 10px;
      }
    }
  }
</style>
